const event =
{
    agree    : 'Voir' ,
    disagree : 'Fermer',
    title    : 'Événement',
    tooltips :
    {
        remove : 'Supprimer'
    }
};

export default event ;